import React, { AnchorHTMLAttributes } from 'react';
import { Link as ReactLink, LinkProps } from 'react-router-dom';

type Props = LinkProps &
	AnchorHTMLAttributes<HTMLAnchorElement> & {
		children: JSX.Element | string;
		to: string;
		redirect?: boolean;
		htmlFor?: string;
	};

const Link = ({
	to,
	children,
	redirect = false,
	...props
}: Props): JSX.Element =>
	!String(to).includes('://') && !redirect ? (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<ReactLink to={to} {...props}>
			{children}
		</ReactLink>
	) : (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<a href={to} {...props}>
			{children}
		</a>
	);

export default Link;
